import { IconName } from "@swisscom/sdx";
import { TCustomerSegment, TLanguage } from "../../types";
import { defaultOceRequestHeaders, fetchWith } from "../fetch";

export interface NotificationItem {
  title: string;
  content: string[];
  link: string;
  iconName: IconName;
}

export interface NotificationResponse {
  items: NotificationItem[];
}

export interface ILabelValue {
  label: string;
  value: string;
}

class NotificationService {
  private hostUrl = "";

  setUrlHost(hostUrl: string): void {
    if (hostUrl) {
      this.hostUrl = hostUrl;
    }
  }

  public loadNotifications(
    scn: string | undefined,
    customerSegment: TCustomerSegment,
    language: TLanguage,
  ): Promise<NotificationResponse> {
    if (scn && scn.length) {
      const params = {
        scn: scn,
      };
      const baseUrl = `${this.hostUrl}/oce/soe/interactions/v1/portal/notifications`;
      return this.getNotificationsResponse(
        baseUrl,
        params,
        customerSegment,
        language,
      );
    }
    return Promise.reject("No logged in user to load the notifications!");
  }

  private async getNotificationsResponse(
    baseUrl: string,
    params: Record<string, string>,
    customerSegment: TCustomerSegment,
    language: TLanguage,
  ): Promise<NotificationResponse> {
    const ttiCustomerDataExchangeId = new URLSearchParams(
      window.location.search,
    ).get("ttiCustomerDataExchangeId");
    if (ttiCustomerDataExchangeId) {
      params.ttiCustomerDataExchangeId = ttiCustomerDataExchangeId;
    }

    const response = await fetchWith(baseUrl, params, {
      headers: defaultOceRequestHeaders(
        "notification-box",
        language,
        customerSegment,
      ),
    });

    return response.body;
  }
}

export interface INotificationService extends NotificationService {}

export const notificationService = new NotificationService();
